import "./EmailLogin.scss";

import React, { useState } from "react";
import apiUser from "../../apis/api.user";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import HeaderNav from "../../components/HeaderNav";
import FooterContent from "../../components/FooterContent"

function EmailLogin() {
  
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const [buttonVerify, setButtonVerify] = useState({name:'Xác thực',state: true})
  
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [tab, setTab] = useState(0);
  const [sendOTPExp, setSendOTPExp] = useState(30);
  const [message, setMessage] = useState([
  ]);
  const [time, setTime] = useState(30);

  function startCountdown(durationInSeconds) {
    let remainingTime = durationInSeconds;
    const interval = setInterval(() => {
      if (remainingTime <= 1) {
        clearInterval(interval);
      }
      remainingTime--;
      setTime(remainingTime);
    }, 1000);
  }

  function startCountdownExp(durationInSeconds) {
    let remainingTime = durationInSeconds;
    const interval = setInterval(() => {
      if (remainingTime <= 1) {
        clearInterval(interval);
      }
      remainingTime--;
      setSendOTPExp(remainingTime);
    }, 1000);
  }

  function checkFields() {
    let message = [];
    let status = true;
    if(!isValidVietnamPhone(phone)){
      message.push("Số điện thoại của bạn không đúng định dạng");
      status = false;
    }
    if(!isValidEmail(email)){
      message.push("Email của bạn không đúng định dạng");
      status = false;
    }
    if(!isValidPassword(password)){
      message.push("Mật khẩu của bạn cần có 8-16 ký tự bao gồm chữ hoa, chữ thường, chữ số và ký tự đặc biệt");
      status = false;
    }
    if(password != confirmPassword){
      message.push("Mật khẩu và Nhập lại mật khẩu của bạn không giống nhau");
      status = false;
    }
    setMessage(message);
    return status;
  }

  function isValidVietnamPhone(phoneNumber) {
    const vietnamPhoneRegex = /^(03|05|07|08|09)\d{8}$/;
    return vietnamPhoneRegex.test(phoneNumber);
  }
  function isValidEmail(email) {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  }
  function isValidPassword(password) {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&*()-+=])[A-Za-z\d@#$%^&*()-+=]{8,}$/;
    return passwordRegex.test(password);
  }

  const handleClickVerify = async () => {
    if(isValidEmail(email)){
      setButtonVerify({name:"Đang xác thực ... ", state: false})
      const res = await apiUser.checkEmailAddress(email);
      if (res) {
        if (res.message === "Email accept") {
          setTab(2);
        } else if (res.message == "Email was not found") {
          await apiUser.getOTP(email);
          setTab(1);
          startCountdownExp(30);
        }
      }else{
        setButtonVerify({name:"Xác thực", state: false})
      }
    }else{
      toast.error("Email của bạn không đúng định dạng");
    }
  };

  const handleClickLogin = async () => {
    setButtonVerify({name:"Đang đăng nhập ... ", state: true})
    let paramLogin = {
      email: email,
      password: password,
    };
    const res = await apiUser.postLogin(paramLogin);
    if(res){
      const user = JSON.stringify(res.elements);
      await localStorage.setItem("user", user);
      navigate(from)
    }else{
      toast.error("Thông tin đăng nhập không chính xác")
      setButtonVerify({name:"Đăng nhập ... ", state: false})
    }
  };

  const handleClickOTP = async () => {
    const res = await apiUser.getOTP(email);
    if(res){
      setTime(60)
    }
    else{
      toast.error("Lấy OTP không thành công")
    }
  };

  const changeEmail = async (e) => {
    setEmail(e);
    if(isValidEmail(email)){
      setButtonVerify({name:"Xác thực", state: false})
    }else{
      setButtonVerify({name:"Xác thực", state: true})
    }
  };

  const changePassword = async (e) => {
    setPassword(e);
  };

  const changeConfirmPassword = async (e) => {
    setConfirmPassword(e);
  };

  const handleClickRegister = async () => {
    let params = {
      email: email,
      phone: phone,
      name: name,
      password: password,
      otp: otp,
    };
    const res = await apiUser.postRegister(params);
    if (res.code === 201) {
      setTab(2);
    }
  };

  const handleClick = (event) => {
    const clickedElement = event.target;
    if (clickedElement.tagName !== 'INPUT' && clickedElement.tagName !== 'BUTTON') {
      checkFields();
    }
  };

  return (
    <>
    <HeaderNav/>
    <div className="email-login-page">
      <ToastContainer />
      <div className="email-login-container" onClick={handleClick}>
        {tab === 0 ? (
          <>
            <h2>Bạn cần đăng nhập để tiếp tục</h2>
            <p>
              Chúng tôi cần xác nhận địa chỉ email của bạn, chỉ mất một chút
              thời gian!
            </p>
            <h2>Email</h2>
            <div className="center">
              <input
                type="email"
                placeholder="example@example.com"
                onChange={(e) => changeEmail(e.target.value)}
              />
            </div>
              <button 
              disabled={buttonVerify.state}
              className="button-style-confirm" 
              onClick={() => handleClickVerify()}>{buttonVerify.name}</button>
          </>
        ) : tab === 1 ? (
          <>
            <h2>Một mã OTP đã gửi về Email của bạn</h2>
            <p>Nhập mã gồm 6 chữ số chúng tôi gửi tới {email} để đăng nhập</p>
            <p>OTP này sẽ hết hạn sau 10 phút</p>
            <div className="center">
              <h2>Thông tin tạo tài khoản</h2>
            </div>
            <input
              type="text"
              placeholder="Họ và tên"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="text"
              placeholder="Số điện thoại"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <input
              type="password"
              placeholder="Mật khẩu"
              value={password}
              onChange={(e) => changePassword(e.target.value)}
            />
            <input
              type="password"
              placeholder="Nhập lại mật khẩu"
              value={confirmPassword}
              onChange={(e) => changeConfirmPassword(e.target.value)}
            />
            <div className="center_otp">
              <input
                type="text"
                placeholder="OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              {sendOTPExp === 0 ? (
               
                  <> <div className="center">
                  <button
                    onClick={() => handleClickOTP()}
                  >
                    Lấy OTP
                  </button>
                  </div>
                </>
              ) : (
                <>
                <div className="center">
                <button
                    disabled
                  >
                    Lấy lại OTP sau {sendOTPExp}s
                  </button>
                  </div>
                </>
              )}
            </div>
            <ul>
              {message.map((item) => (
                <>
                    <>
                      <li>{item}</li>
                    </>
                </>
              ))}
            </ul>
            <button className="button-style-confirm" onClick={() => handleClickRegister()}>Đăng ký</button>
          </>
        ) : tab === 2 ? (
          <>
            <h2>Mật khẩu của bạn là</h2>
            <input
              type="password"
              placeholder="Mật khẩu"
              value={password}
              onChange={(e) => changePassword(e.target.value)}
            />
            <button
            className="button-style-confirm" 
            onClick={() => handleClickLogin()}>Đăng nhập</button>
            <div className="center">
              <a href="#" onClick={()=> setTab(3)}>Bạn đã quên mật khẩu ?</a>
            </div>
          </>
        ) : (
          <>
            <h2>
              Đăng nhập thành công. Đang chuyển hướng về trang chủ sau {time} s
            </h2>
          </>
        )}
      </div>
    </div>
    <FooterContent/>
    </>
  );
}
export default EmailLogin;
